import { makeAutoObservable } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import { ConversationRoutes } from 'entities/ExportRouters'

export class LandingMobilePageStore {
  private _title = 'Never miss a lead'
  private _description = 'Get the app to call and text your contacts the moment they reach out'

  constructor() {
    makeAutoObservable(this)
  }

  get title() {
    return this._title
  }

  get description() {
    return this._description
  }

  continueToApp = () => {
    window.localStorage.setItem('landing_mobile_exist', 'true')
    uiStore.changeRouteViaVue({ path: `/${ConversationRoutes.root}` })
  }
}
